"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parameterFactory = exports.UnrecognisedParameter = exports.ObjectParameter = exports.ArrayParameter = exports.PrimitiveParameterWithValidation = exports.PrimitiveParameter = exports.BFParameter = exports.BFParameterType = exports.REF = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("./utils");
const Validator_1 = require("./Validator");
function isPrimitiveParameter(param) {
    return utils_1.isPrimitive(param);
}
function isPrimitiveParameterWithValidation(param) {
    return (lodash_1.isObject(param) &&
        utils_1.isPrimitive(param.value));
}
function isObjectParameter(param) {
    return param.type === 'object';
}
function isArrayParameter(param) {
    return param.type === 'array';
}
exports.REF = `$$ref.`;
var BFParameterType;
(function (BFParameterType) {
    BFParameterType["PrimitiveType"] = "PrimitiveType";
    BFParameterType["PrimitiveParameterWithValidation"] = "PrimitiveWithValidation";
    BFParameterType["ArrayParameter"] = "ArrayType";
    BFParameterType["ObjectParameter"] = "ObjectType";
})(BFParameterType = exports.BFParameterType || (exports.BFParameterType = {}));
class BFParameter {
}
exports.BFParameter = BFParameter;
class PrimitiveParameter extends BFParameter {
    constructor(paramVal, extras) {
        super();
        this.extras = extras;
        this.paramVal = paramVal;
    }
    isEqual(paramVal) {
        const currentVal = this.getValToEmit();
        const isValid = paramVal === currentVal;
        if (!isValid) {
            return `${paramVal}` === `${currentVal}`;
        }
        return isValid;
    }
    getValToEmit() {
        return this.extras.store.getFromRefVal(this.paramVal);
    }
}
exports.PrimitiveParameter = PrimitiveParameter;
class PrimitiveParameterWithValidation extends BFParameter {
    constructor(paramVal, extras) {
        super();
        this.extras = extras;
        this.paramVal = paramVal;
        if (paramVal.valueValidation) {
            this.validation = new Validator_1.Validator(paramVal.valueValidation, this.extras);
        }
    }
    isEqual(val) {
        if (this.validation) {
            return this.validation.validate(this.paramVal.value, val);
        }
        if (this.paramVal.type === 'boolean') {
            // TODO: temporary fix, boolean types are not properly handled in builder
            return (`${val}` == `${this.extras.store.getFromRefVal(this.paramVal.value)}`);
        }
        return val === this.extras.store.getFromRefVal(this.paramVal.value);
    }
    getValToEmit() {
        if (this.validation) {
            return this.validation.getValToEmit(this.paramVal.value);
        }
        return this.extras.store.getFromRefVal(this.paramVal.value);
    }
}
exports.PrimitiveParameterWithValidation = PrimitiveParameterWithValidation;
class ArrayParameter extends BFParameter {
    constructor(paramVal, extras) {
        super();
        this.extras = extras;
        const value = paramVal.value;
        console.log('array parameter constructor', paramVal);
        if (value) {
            this.paramVal = value.map((param) => primitiveFactory(param, this.extras));
        }
        else {
            this.paramVal = [];
        }
    }
    isEqual(val) {
        if (!lodash_1.isArray(val)) {
            return false;
        }
        return !this.paramVal.some((item, index) => !item.isEqual(val[index]));
    }
    getValToEmit() {
        return this.paramVal.map((param) => param.getValToEmit());
    }
}
exports.ArrayParameter = ArrayParameter;
class ObjectParameter extends BFParameter {
    constructor(paramVal, extras) {
        super();
        this.extras = extras;
        const value = paramVal.value;
        if (value) {
            this.paramVal = Object.keys(value).reduce((acc, key) => {
                const param = value[key];
                if (isPrimitiveParameter(param)) {
                    acc[key] = new PrimitiveParameter(param, this.extras);
                }
                if (isPrimitiveParameterWithValidation(param)) {
                    acc[key] = new PrimitiveParameterWithValidation(param, this.extras);
                }
                return acc;
            }, {});
        }
        else {
            this.paramVal = {};
        }
    }
    getValToEmit() {
        return Object.keys(this.paramVal).reduce((acc, key) => {
            acc[key] = this.paramVal[key].getValToEmit();
            return acc;
        }, {});
    }
    isEqual(val) {
        try {
            let validStructure = true;
            if (Object.keys(this.paramVal).length !== Object.keys(val).length) {
                validStructure = false;
            }
            if (!validStructure) {
                return false;
            }
            return !Object.keys(this.paramVal).some((key) => !this.paramVal[key].isEqual(val[key]));
        }
        catch (err) {
            return false;
        }
    }
}
exports.ObjectParameter = ObjectParameter;
class UnrecognisedParameter extends BFParameter {
    constructor(paramVal) {
        super();
        // this class should never be instantiated, if it is instantiated
        // then the lesson definition is wrong.
        this.isNotRecognised = true;
        this.paramVal = paramVal;
    }
    isEqual() {
        throw new Error('UnrecognisedParameter found. Not implemented');
        return true;
    }
    getValToEmit() {
        throw new Error('UnrecognisedParameter found. Not implemented');
    }
}
exports.UnrecognisedParameter = UnrecognisedParameter;
function primitiveFactory(parameter, extras) {
    if (isPrimitiveParameter(parameter)) {
        return new PrimitiveParameter(parameter, extras);
    }
    if (isPrimitiveParameterWithValidation(parameter)) {
        return new PrimitiveParameterWithValidation(parameter, extras);
    }
    if (isObjectParameter(parameter)) {
        return new ObjectParameter(parameter, extras);
    }
    return new UnrecognisedParameter(parameter);
}
function parameterFactory(parameter, extras) {
    if (isPrimitiveParameter(parameter)) {
        return new PrimitiveParameter(parameter, extras);
    }
    if (isPrimitiveParameterWithValidation(parameter)) {
        return new PrimitiveParameterWithValidation(parameter, extras);
    }
    if (isObjectParameter(parameter)) {
        return new ObjectParameter(parameter, extras);
    }
    if (isArrayParameter(parameter)) {
        return new ArrayParameter(parameter, extras);
    }
    return new UnrecognisedParameter(parameter);
}
exports.parameterFactory = parameterFactory;
//# sourceMappingURL=data:application/json;base64,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